import {
  TOGGLE_FILTER_SIDEBAR,
  CLOSE_FILTER_SIDEBAR,
  TOGGLE_LEFT_MENU_SIDEBAR,
  OPEN_CREATE_NEW_SIDEBAR,
  OPEN_EDIT_SIDEBAR,
} from '../constants';

export const initialSidebarState = {
  advancedFilterMenuOpen: false,
  leftMenuSideBarVisible: true,
  leftMenuSideBarCollapsed: false,
  sideBarStatus: 'edit',
};

export default (state = initialSidebarState, action) => {
  function useQuery() {
    return new URLSearchParams(window.location.search);
  }
  const q = useQuery();
  let appliedFilterProfileUUID = q
    ?.get('filterProfile')
    ?.split('?filterProfile=')[0]
    ?.replace('?openAdvancedFilter=true', '');

  switch (action?.type) {
    case TOGGLE_FILTER_SIDEBAR:
      if (state.advancedFilterMenuOpen) {
        if (state.sideBarStatus === 'create') {
          window.history.replaceState(
            null,
            '',
            '/?openCreateNewAdvancedFilter=true',
          );
        } else {
          window.history.replaceState(
            null,
            '',
            appliedFilterProfileUUID
              ? `/?filterProfile=${appliedFilterProfileUUID}`
              : '/',
          );
        }
      } else {
        if (state.sideBarStatus === 'create') {
          window.history.replaceState(
            null,
            '',
            '/?openAdvancedFilter=true?openCreateNewAdvancedFilter=true',
          );
        } else {
          window.history.replaceState(
            null,
            '',
            appliedFilterProfileUUID
              ? `/?filterProfile=${appliedFilterProfileUUID}?openAdvancedFilter=true`
              : '/?openAdvancedFilter=true',
          );
        }
      }

      return {
        advancedFilterMenuOpen: state.advancedFilterMenuOpen ? false : true,
        leftMenuSideBarVisible: true,
        leftMenuSideBarCollapsed: state.advancedFilterMenuOpen ? false : true,
        sideBarStatus: window?.location?.href?.includes(
          'openCreateNewAdvancedFilter=true',
        )
          ? 'create'
          : 'edit',
      };

    case CLOSE_FILTER_SIDEBAR:
      return {
        advancedFilterMenuOpen: false,
        leftMenuSideBarVisible: true,
        leftMenuSideBarCollapsed: false,
        sideBarStatus: window?.location?.href?.includes(
          'openCreateNewAdvancedFilter=true',
        )
          ? 'create'
          : 'edit',
      };
    case TOGGLE_LEFT_MENU_SIDEBAR:
      return {
        advancedFilterMenuOpen: false,
        leftMenuSideBarVisible: true,
        leftMenuSideBarCollapsed: !state.leftMenuSideBarCollapsed,
      };
    case OPEN_CREATE_NEW_SIDEBAR:
      return {
        advancedFilterMenuOpen: true,
        leftMenuSideBarVisible: true,
        leftMenuSideBarCollapsed: true,
        sideBarStatus: 'create',
      };
    case OPEN_EDIT_SIDEBAR:
      return {
        advancedFilterMenuOpen: true,
        leftMenuSideBarVisible: true,
        leftMenuSideBarCollapsed: true,
        sideBarStatus: 'edit',
      };
    default:
      return state;
  }
};
